<template>
  <div class="text-center centered-container" v-if="loadingData">
    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
  </div>
  <div v-else>
    <div style="height: 100%">
      <v-slide-x-transition leave-absolute hide-on-leave :duration="{ enter: 5000, leave: 8000 }">
        <component class="rsu" v-if="!loading" :is="view"></component>
      </v-slide-x-transition>
    </div>
  </div>
</template>

<script>
import Register from "./Register.vue";
import queryString from "query-string";

import Agreement from "./Registration/Agreement.vue";
import Registration from "./Registration/main.vue";
import HistoryList from "./historyList/main.vue";
import OTP from "./Registration/OTP.vue";
import Createpin from "./Registration/Createpin.vue";
import Verifyinfo from "./Verify/Verifyinfo.vue";
import VerifyRegular from "./Verify/VerifyRegular.vue";
import VerifyTaxID from "./Verify/VerifyTaxID.vue";
import VerifyNoTaxID from "./Verify/VerifyNoTaxID.vue";
import Profile from "./Profile/main.vue";
import CustomForm from "./CustomForm/main.vue";
import ShowError from "./CustomForm/ShowError.vue";
import NewsUpdate from "./RichMenu/NewsUpdate.vue";
import JobD2U from "./RichMenu/JobD2U.vue";
// import JobDetail from "./RichMenu/JobDetail.vue";
import NewsRead from "./RichMenu/NewsRead.vue";
import Seminar from "./RichMenu/Seminar.vue";
import Contact from "./RichMenu/Contact.vue";
import Login from "./Login.vue";
import axios from "axios";
import Term from "./Registration/Term.vue";
import FormForgetpassword from "./FormForgetpassword.vue";
import Payment from "./Payment.vue";

export default {
  components: {
    Register,
    FormForgetpassword,
    Agreement,
    Registration,
    OTP,
    Createpin,
    Verifyinfo,
    VerifyRegular,
    VerifyTaxID,
    VerifyNoTaxID,
    Profile,
    CustomForm,
    NewsUpdate,
    JobD2U,
    Seminar,
    Contact,
    Login,
    Term,
    NewsRead,
    ShowError,
    HistoryList,
    Payment,
    // JobDetail,
  },
  data() {
    return {
      loading: true,
      loadingData: true,
    };
  },
  async mounted() {
    var vm = this;
    vm.queryinit();
    await vm.init();
    await vm.depacheckmemberinfo();
    vm.loading = false;
    vm.loadingData = false;
  },
  methods: {
    depacheckmemberinfo() {
      return new Promise((resolve) => {
        axios
          .get(this.serverUrl + "depacheckmemberinfo", {
            params: {
              userid: this.userid,
              pageid: this.query.pageid,
            },
            headers: {
              // AUTHORIZATION: this.headers,
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.memberData = response.data.data[0];
              this.$store.state.memberid = response.data.data[0].memberid;
              this.$store.state.profiledata = response.data.data[0];
              this.$store.state.sessiontoken =
                response.data.data[0].sessiontoken;
              this.$store.state.registerStatus = true;
              if (
                response.data.data[0].status == "unconfirmed" ||
                response.data.data[0].status == "rejected"
              ) {
                this.query.view = "Verifyinfo";
              }
              resolve();
            } else {
              this.$store.state.registerStatus = false;
              this.query.view = "Login";
              resolve();
            }
          });
      });
    },
    init() {
      var vm = this;
      return new Promise(async (resolve) => {
        // var liffid = "1656580011-p2A1G37E"; //prod bot prod  https://dossliff.depa.or.th/
        // var liffid = "1656580011-BYR8PYW9"; //prod bot local  https://dossliff.depa.or.th/
        // var liffid = "1656472648-9PlkqokQ"; //main
        // var liffid = "1654951993-7gE1aoXY"; //staging bot prod https://depa.zwiz.ai
        // var liffid = "1654951993-kDgZNaK6"; //staging bot local https://depa.zwiz.ai

        var liffid = this.liffid;

        if (this.query.apptype == "line") {
          await this.initializeLiff(liffid);
          this.$store.state.userid =
            this.$store.state.profile.userId + "__" + this.query.pageid;
          resolve();
        } else {
          this.$store.state.userid = this.query.userid + "__DEPA";
          window.extAsyncInit = function () {
            // the Messenger Extensions JS SDK is done loading
          };
          resolve();
        }
      });
    },
    initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      return new Promise(async (resolve) => {
        try {
          await this.$liff.init({
            liffId: myLiffId,
          });
        } catch (error) {
          console.error(error.message);
        }
        if (await this.$liff.isLoggedIn()) {
          this.$store.state.profile = await this.$liff.getProfile();
          resolve();
        } else {
          await this.$liff.login({ redirectUri });
          resolve();
        }
      });
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
};
</script>

<style lang="scss">
.slide-x-transition-enter-active,
.slide-x-transition-leave-active {
  transition-duration: 0.2s !important;
}

.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.depahead {
  font-weight: bold;
  font-size: 25px;
  font-weight: 100;
  color: #7b7b7b;
  margin-bottom: 20px;
}

.submitbtn {
  width: 170px;
  margin-left: auto;
  margin-right: auto;
}

.submitbtn .v-btn {
  font-size: 20px;
  border-radius: 8px;
}

.depahead {
  background-color: #0c2f53;
  color: white;
  padding: 18px;
  font-weight: 400;
  font-size: 26px;
}

.depatitle {
  font-size: 21px;
  font-weight: 900;
}

.flex-all-center {
  display: flex;
  justify-content: center;
  align-content: center;
}

.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
</style>
